/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocIcon20Solid = forwardRef('DocIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.004 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7.998h-3.746a2.25 2.25 0 0 1-2.25-2.25V2Z" }),
        React.createElement("path", { d: "m15.863 6.498-4.359-4.359v3.609c0 .414.336.75.75.75h3.61Z" })));
});
